var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"path-1-inside-1_4519_11","fill":"white","key":0},React.createElement("path",{"d":"M0 0H35V40H0V0Z"})),React.createElement("path",{"d":"M1 40V0H-1V40H1Z","fill":"#E5E5E5","mask":"url(#path-1-inside-1_4519_11)","key":1}),React.createElement("path",{"d":"M10.5 20H24.5","stroke":"#27788C","strokeWidth":"2","key":2})]);
}

IconClose.defaultProps = {"width":"35","height":"40","viewBox":"0 0 35 40","fill":"none"};

module.exports = IconClose;

IconClose.default = IconClose;
